import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { resetRechercheCriteres, updateRechercheCriteres, setRechercheCritereFiltre, setRechercheCritereCodeDepot, fetchReclamations, fetchReclamationsMagasin, fetchReclamationsIfNeeded } from 'store/reclamation/reclamationsActions';
import { clearFournisseurValue } from 'store/fournisseur/fournisseurActions';
import { clearTransporteurValue } from 'store/transporteur/transporteurActions';
import { clearClientValue } from 'store/client/clientActions';
import { clearArticleGestionValue } from 'store/articleGestion/articlesGestionActions';
import { clearUtilisateurValue } from 'store/utilisateur/utilisateursActions';
import { clearAgenceValue } from 'store/agence/agenceActions';

import { ReclamationFiltre } from 'constants.js';

import ReclamationsSearchFilters from './ReclamationsSearchFilters';
import ReclamationsRetourPlateformeSearchFilters from './ReclamationsRetourPlateformeSearchFilters';

class ReclamationsSearchFiltersContainer extends React.Component {

    async componentDidMount() {


        if (this.props.filtre === ReclamationFiltre.RetourPlateforme) {

            let codeDepot = '';

            let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));

            //console.log(utilisateur);

            if (!utilisateur.administrateur) {
                if (utilisateur.depot && utilisateur.depot.code != '01' && utilisateur.depot.code != '70') {
                    codeDepot = utilisateur.depot.code;
                }
                else
                {
                    let magasins = utilisateur.depots.filter(x => x.code != '01' && x.code != '70');
                    codeDepot = magasins.length > 0 ? magasins[0].code : '';
                }
            }

            //console.log('codeDepot', codeDepot);

            await this.props.setRechercheCritereCodeDepot(codeDepot);

            await this.props.fetchReclamationsMagasin();

        }
        else {
            await this.props.fetchReclamationsIfNeeded();
        }
    }

    componentDidUpdate(prevProps) {

        if (prevProps.filtre !== this.props.filtre)
        {

            if (this.props.filtre === ReclamationFiltre.RetourPlateforme) {


                let codeDepot = '';

                let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));


                if (!utilisateur.administrateur) {
                    if (utilisateur.depot && utilisateur.depot.code != '01' && utilisateur.depot.code != '70') {
                        codeDepot = utilisateur.depot.code;
                    }
                    else {
                        let magasins = utilisateur.depots.filter(x => x.code != '01' && x.code != '70');
                        codeDepot = magasins.length > 0 ? magasins[0].code : '';
                    }
                }


                this.props.setRechercheCritereCodeDepot(codeDepot);

                this.props.fetchReclamationsMagasin();

            }
            else {
                this.props.fetchReclamationsIfNeeded();
            }
        }

    }


    handleChange = event => {
        let criteres = { ...this.props.criteres };
        criteres[event.target.name] = event.target.value;

        this.props.updateRechercheCriteres(criteres);
    };

    handleClickSearch = () => {
        this.props.updateRechercheCriteres({ ...this.props.criteres, page: 1 });

        if (this.props.filtre === ReclamationFiltre.RetourPlateforme) {
            this.props.fetchReclamationsMagasin();
        }
        else {
            this.props.fetchReclamations();
        }
    }

    handleClickReset = () => {
        this.props.resetRechercheCriteres();
        this.props.clearFournisseurValue("searchFilters");
        this.props.clearTransporteurValue("searchFilters");
        this.props.clearClientValue("searchFilters");
        this.props.clearArticleGestionValue("searchFilters");
        this.props.clearAgenceValue();

        this.props.clearUtilisateurValue("searchFiltersUtilisateur");
        this.props.clearUtilisateurValue("searchFiltersEmetteur");
        this.props.clearUtilisateurValue("searchFiltersUtilisateurPreneurOrdre");
        this.props.clearUtilisateurValue("searchFiltersObservateur");
    }

    handleChangeClient = (client) => {
        let criteres = { ...this.props.criteres };
        criteres.clientId = client.id;
        criteres.client = {...client }
;

        this.props.updateRechercheCriteres(criteres);
    }

    handleChangeArticleGestion = (suggestion) => {
        let criteres = { ...this.props.criteres };
        criteres.codeArticle = suggestion.reference;
        this.props.updateRechercheCriteres(criteres);
    }
    handleChangeConcerne = (value) => {
        let criteres = { ...this.props.criteres };
        criteres.codeArticleConcerne = value;
        this.props.updateRechercheCriteres(criteres);
    }

    handleChangeTransporteur = (id) => {
        let criteres = { ...this.props.criteres };
        criteres.TransporteurId = id;

        this.props.updateRechercheCriteres(criteres);
    }

    handleChangeFournisseur = (id, code) => {
        let criteres = { ...this.props.criteres };
        criteres.fournisseurCode = code;

        this.props.updateRechercheCriteres(criteres);
    }

    handleChangeEmetteur = (id) => {
        let criteres = { ...this.props.criteres };
        criteres.emetteurId = id;
        this.props.updateRechercheCriteres(criteres);
    }

    handleChangeUtilisateur = (id) => {
        let criteres = { ...this.props.criteres };
        criteres.utilisateurId = id;
        this.props.updateRechercheCriteres(criteres);
    }

    handleChangeObservateur = (id) => {
        let criteres = { ...this.props.criteres };
        criteres.observateurId = id;
        this.props.updateRechercheCriteres(criteres);
    }

    handleChangeUtilisateurPreneurOrdre = (id, codePO) => {
        let criteres = { ...this.props.criteres };
        criteres.utilisateurPreneurOrdreCodePO = codePO;

        this.props.updateRechercheCriteres(criteres);
    }

    handleChangeAgence = (id, code) => {
        let criteres = { ...this.props.criteres };
        criteres.codeAgence = code;

        this.props.updateRechercheCriteres(criteres);
    }

    handleChangeDepotGestion = (id, code) => {
        const { filtre, fetchReclamationsMagasin } = this.props;
        let criteres = { ...this.props.criteres };
        criteres.codeDepot = code;

        this.props.updateRechercheCriteres(criteres);

        if (filtre === ReclamationFiltre.RetourPlateforme) {
            fetchReclamationsMagasin();
        }

    }



    render() {
        const { filtre } = this.props;

        if (filtre === ReclamationFiltre.RetourPlateforme) {
            return (
                <ReclamationsRetourPlateformeSearchFilters
                    criteres={this.props.criteres}
                    onChangeDepotGestion={this.handleChangeDepotGestion}
                />
            );
        }

        return (
            <ReclamationsSearchFilters
                onChange={this.handleChange}
                onClickSearch={this.handleClickSearch}
                onClickReset={this.handleClickReset}
                criteres={this.props.criteres}
                onChangeClient={this.handleChangeClient}
                onChangeTransporteur={this.handleChangeTransporteur}
                onChangeFournisseur={this.handleChangeFournisseur}
                onChangeArticleGestion={this.handleChangeArticleGestion}
                onChangeAgence={this.handleChangeAgence}
                onChangeEmetteur={this.handleChangeEmetteur}
                onChangeUtilisateur={this.handleChangeUtilisateur}
                onChangeUtilisateurPreneurOrdre={this.handleChangeUtilisateurPreneurOrdre}
                onChangeConcerne={this.handleChangeConcerne}
                onChangeObservateur={this.handleChangeObservateur}
            />
        );
    }
}

const mapStateToProps = state => ({
    criteres: state.reclamation.reclamations.recherche.criteres
});

const mapDispatchToProps = dispatch => ({
    resetRechercheCriteres: () => dispatch(resetRechercheCriteres()),
    updateRechercheCriteres: criteres => dispatch(updateRechercheCriteres(criteres)),
    setRechercheCritereFiltre: filtre => dispatch(setRechercheCritereFiltre(filtre)),
    setRechercheCritereCodeDepot: codeDepot => dispatch(setRechercheCritereCodeDepot(codeDepot)),
    fetchReclamations: () => dispatch(fetchReclamations()),
    fetchReclamationsIfNeeded: () => dispatch(fetchReclamationsIfNeeded()),
    fetchReclamationsMagasin: () => dispatch(fetchReclamationsMagasin()),
    clearTransporteurValue: (namespace) => dispatch(clearTransporteurValue(namespace)),
    clearFournisseurValue: (namespace) => dispatch(clearFournisseurValue(namespace)),
    clearClientValue: (namespace) => dispatch(clearClientValue(namespace)),
    clearArticleGestionValue: (namespace) => dispatch(clearArticleGestionValue(namespace)),
    clearAgenceValue: () => dispatch(clearAgenceValue()),
    clearUtilisateurValue: (namespace) => dispatch(clearUtilisateurValue(namespace))
});


ReclamationsSearchFiltersContainer.propTypes = {
    filtre: PropTypes.number.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(ReclamationsSearchFiltersContainer);